export default __webpack_public_path__ + "static/media/A6.49e104e2.jpg";